/**
 * @generated SignedSource<<46776904579882bbd813738aa49b0642>>
 * @relayHash b9cf4b171e22923a16ac0f89aedfe3f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c155c1b708ada466d10a0aef2cc9865e9b049be1525660c7e87a9a115452517c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIssueSearchFieldSetSelectedState = "ALL" | "NON_SELECTED" | "SELECTED" | "%future added value";
export type JiraIssueSearchFieldSetsFilter = {
  fieldSetSelectedState?: JiraIssueSearchFieldSetSelectedState | null | undefined;
  searchString?: string | null | undefined;
};
export type columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  filter?: JiraIssueSearchFieldSetsFilter | null | undefined;
  first?: number | null | undefined;
  namespace?: string | null | undefined;
};
export type columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery$data = {
  readonly jira: {
    readonly issueSearchViewByNamespaceAndViewId: {
      readonly fieldSets: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly fieldSetId: string | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery = {
  response: columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery$data;
  variables: columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "namespace",
    "variableName": "namespace"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "filter",
      "variableName": "filter"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ],
  "concreteType": "JiraIssueSearchFieldSetConnection",
  "kind": "LinkedField",
  "name": "fieldSets",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalCount"
    },
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        }
      ]
    },
    {
      "concreteType": "JiraIssueSearchFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "cursor"
        },
        {
          "concreteType": "JiraIssueSearchFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fieldSetId"
            },
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "concreteType": "JiraFieldType",
              "kind": "LinkedField",
              "name": "fieldType",
              "plural": false,
              "selections": [
                (v6/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchView",
            "kind": "LinkedField",
            "name": "issueSearchViewByNamespaceAndViewId",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchView",
            "kind": "LinkedField",
            "name": "issueSearchViewByNamespaceAndViewId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c155c1b708ada466d10a0aef2cc9865e9b049be1525660c7e87a9a115452517c",
    "metadata": {},
    "name": "columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3d1328a1ab83ad6fbd72932a00cf8a36";

export default node;
